module.exports = __webpack_public_path__ + "./kit/docs/img/search-filter-hover.a8d466bbbe6322ce6f5d262589ab0728.svg";